<template>
  <custom-button
    @click.stop="$emit('onClick')"
    has-font-semi-bold
    button-type="white"
  >
    <span class="d-flex align-items-center column-gap-2">
      <IconAILinear />
      <span class="d-flex align-items-center column-gap-2">
        {{ label }}
      </span>
    </span>
  </custom-button>
</template>

<script setup>
import { TrainingStatusEnum } from "@/constants/trainings";

const emit = defineEmits("onClick");

const props = defineProps({
  training: {
    type: Object,
    default: {},
  },
  isUserApprover: {
    type: Boolean,
    default: true,
  },
});

const hasTraining = computed(() => {
  return Object.keys(props.training || {}).length > 0 && !props.training.is_new;
});

const possibleLabels = {
  initiate: "Initiate Training",
  continue: "Continue Training",
  view: "View Training",
  review: "Review Training",
};

const label = computed(() => {
  const trainingStatus = props.training.Status;

  if (!hasTraining.value) {
    return possibleLabels.initiate;
  } else {
    if (trainingStatus === TrainingStatusEnum.REVIEW) {
      return possibleLabels.continue;
    }

    if (
      [TrainingStatusEnum.LIVE, TrainingStatusEnum.REJECTED].includes(
        trainingStatus,
      )
    ) {
      return possibleLabels.view;
    }

    if (trainingStatus === TrainingStatusEnum.PENDING) {
      if (props.isUserApprover) {
        return possibleLabels.review;
      }

      return possibleLabels.view;
    }
  }
});
</script>
